import { TextField } from "@mui/material";
import { useState } from "react";
import { useDispatch } from "react-redux";

import DatePicker from "react-datepicker";

import "react-datepicker/dist/react-datepicker.css";
import styles from "./datepicker.module.css";
import { testId } from "../../../../testUtils/testId";
import { TimeEntry, timeEntryAdded, timeEntryCreatedManually, timeEntryUpdated } from "../../store";

interface TimeEntryCreateProps {
  typeText: string,
  setCreateFormVisible: (flag: boolean) => void;
  setselectedEntryDisabled: (flag: boolean) => void;
}

export const TimeEntryCreate: React.FC<TimeEntryCreateProps> = ({
  typeText,
  setCreateFormVisible,
  setselectedEntryDisabled
}) => {
  const dispatch = useDispatch();

  const handleCancel = () => {
    setCreateFormVisible(false);
    setselectedEntryDisabled(false);
  };

  const handleSave = () => {
    dispatch(timeEntryCreatedManually({ text: entryText, startTime: startTimeValue, endTime: stopTimeValue }));
    setCreateFormVisible(false);
  };

  const [startTimeValue, setStartTimeValue] = useState<number>(
    new Date().getTime()
  );
  const [stopTimeValue, setStopTimeValue] = useState<number>(
    new Date().getTime()
  );
  const [entryText, setEntryText] = useState<string>(typeText);

  const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setEntryText(event.target.value);
  };

  return (
    <div className="mt-4 mb-2">
      <div className="flex flex-row gap-[10px]">
        <TextField
          label="Type"
          value={entryText}
          onChange={handleTextChange}
          className="flex-grow"
          disabled={true}
        />
        <div data-testid={testId.startTime}>
          <DatePicker
            className="border border-gray_border rounded hover:border-black focus:outline-blue-500"
            selected={new Date(startTimeValue)}
            wrapperClassName={styles.date_picker}
            onChange={(date: Date) =>
              date && setStartTimeValue(date?.getTime())
            }
            timeInputLabel="Time:"
            dateFormat="HH:mm"
            showTimeInput
          />
        </div>
        <div data-testid={testId.stopTime}>
          <DatePicker
            className="border border-gray_border rounded hover:border-black focus:outline-blue-500"
            disabled={!stopTimeValue}
            wrapperClassName={styles.date_picker}
            selected={
              stopTimeValue ? new Date(stopTimeValue) : new Date(Date.now())
            }
            onChange={(date: Date) => date && setStopTimeValue(date?.getTime())}
            timeInputLabel="Time:"
            dateFormat="HH:mm"
            showTimeInput
          />
        </div>
      </div>
      <div className="pt-[10px] flex flex-row justify-end gap-[10px]">
        <button
          onClick={handleCancel}
          className="bg-white border-2 border-blue-600 rounded text-blue-600 hover:text-blue-800 hover:border-blue-800 px-3 py-1.5 font-medium"
        >
          Cancel
        </button>
        <button
          onClick={handleSave}
          className="bg-blue-600 rounded text-white hover:bg-blue-800 px-3 py-1.5 font-medium"
        >
          Save
        </button>
      </div>
    </div>
  );
};
